export default __webpack_public_path__ + "static/media/G0880-Management_of_bleeding.1702899420000.714d034d.jpg";